module.exports = __webpack_public_path__ + "img/ph.2367f32.svg";